define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/topic",
	"dojo/query",
	"dijit/MenuItem",
	"csi/_base/underscore",
	"csi/action/New",
	"csi/action/Popup",
	"csi/def/ViewRef",
	"csi/html",
	"csi/locale",
	"csi/page/SearchManager",
	"csi/reflection",
	"csi/service/imageService",
	"csi/state/rootStore",
	"csi/utility/routerUtility",
	"csi/view/ToolbarDropDown",
	"csi/widget/DropDownMenu",
	"csi/xml",
	"dojo/text!csi/templates/card.html"
], function(declare, lang, topic, query, MenuItem, _, NewAction, Popup, ViewRef,
	html, locale, SearchManager, reflection, {waitForImagesToLoad}, {sessionStore}, routerUtility, ToolbarDropDown, DropDownMenu, xml, template) {

	const {
		decomposeHash,
		getLocationForUrl,
	} = routerUtility;

	return declare(ToolbarDropDown, {
		iconClass: "",
		showLabel: false,

		startup: function() {
			if (this._started) return;
			this.inherited(arguments);
		},

		closeDropDown: function(/*Boolean*/focus) {
			if (this.dropDown) {
				if (!this.dropDown.focusedChild || this.dropDown.focusedChild.nodeType != "more") {
					this.inherited(arguments);
				}
			}
		},

		loadDropDown: function(/*Function*/callback) {
			if (this.dropDown) {
				this.inherited(arguments);
			}
		},

		postCreate: function() {
			this.inherited(arguments);
			this.addTooltip(this, this.defAction.m_id);
		},

		async onClick() {
			if (!sessionStore.userPreferences.Favorites.length) {
				this._invokeAction(this.getAddAction());
			} else {
				if (!this.dropDown) {
					this._createDropDown();
				}
				await waitForImagesToLoad();
				this.openDropDown();
			}
		},

		enablePlugin: function( /*Context?*/ ctx) {
			this._setDisabled(this, !ctx);
		},

		getAddAction: function() {
			var addAction = lang.mixin(new NewAction(), {
				classController: "csi.action.FavoriteController",
				m_id: "AddToFavorites",
				m_typeNode: "Favorite"
			});
			addAction.resolve();
			return addAction;
		},

		getEditAction: function() {
			var editAction = lang.mixin(new Popup(), {
				m_id: "FavoritesPopup",
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "Favorites",
					m_url: sessionStore.userPreferencesUrl
				}),
				m_postAction: function() {
					topic.publish("/csi/pageHeader/refresh");
					topic.publish("/csi/favoriteTable/refresh");
				}
			});
			editAction.resolve();
			return editAction;
		},

		_createDropDown: function() {
			var favorites = sessionStore.userPreferences.Favorites;
			var page = 10;
			var count = 0;
			var url = sessionStore.userPreferencesUrl;
			var ctx = this.actionToolbar.view.getContext(null, url, "Favorites");
			var editAction = this.getEditAction();
			var addAction = this.getAddAction();
			ctx.bPopup = true;
			ctx.bReserveClick = true;
			ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;

			if (favorites.length) {
				this.dropDown = new DropDownMenu({
					"class": "csi-nav-dropdown csi-nav-dropdown-list",
					refNode: this.domNode
				});
				var self = this;
				var addNewItem = new MenuItem({
					"class": "csi-nav-dropdown-first-item",
					nodeType: "new",
					onClick: function(e) {
						var action = _.findWhere([addAction, editAction], {m_id: html.getElementAction(e.target)});
						if (action) {
							self._invokeAction(action);
						}
					}
				});

				html.create('span', {innerText: locale.resource("Favorites"), "class": "csi-nav-dropdown-label csi-nav-dropdown-favorite-label"}, addNewItem.textDirNode);
				var div = html.create("div", {"class": "csi-nav-dropdown-custom-item"}, addNewItem.textDirNode);
				editAction.toHtml(ctx, div);
				html.create('span', {innerText: "  |  ", "class": "favorite-actions-divider"}, div);
				addAction.toHtml(ctx, div);
				this.dropDown.addChild(addNewItem);
				ctx.setReadOnly(true);
			}

			ctx.forEach(favorites, function(ctx, i) {
				var favorite = ctx.getNode();
				if (!favorite) return;

				var node = ctx.cache.getNode(favorite.__FavoriteItem__);
				if (!node) return;

				const locationParams = decomposeHash(favorite.Location);
				const href = getLocationForUrl(node.$URL, locationParams);

				if (i && (i % page == 0)) {
					var moreClass = (count == 0) ? "more" : "more hide";
					count += page;
					var queryClass = ".page" + count;
					var moreNode = new MenuItem({
						"class": moreClass + " page" + (count - page),
						label: _.escape(locale.resource("ViewQueryMore")),
						nodeType: "more",
						onClick: function() {
							var parentNode = this.domNode.parentNode;
							query(queryClass, parentNode).removeClass("hide");

							//to prevent the dropDown from closing due to losing focus in Chrome
							this.domNode.previousElementSibling.focus();
							parentNode.removeChild(this.domNode);
						}
					});

					this.dropDown.addChild(moreNode);
				}

				var item = new MenuItem({
					"class": i < page ? "" : "hide page" + count,
					label: template,
					nodeType: "item",
					onClick: function(e) {
						if (e.button === 0) {
							html.openWindowOnMouseClick(e, href);
						}
					}
				});

				var defs = SearchManager.getCardItemDefs(favorite.$Type, favorite, xml.path("__FavoriteItem__"));
				var rowNode = html.templateToHtml(ctx, item.containerNode, defs);
				html.createRowAnchor(rowNode, href);
				this.dropDown.addChild(item);
			}, this);
		}
	});
});